import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'conversationLimit'
	| 'infoIconLabel'
	| 'rovoIsThinking'
	| 'agentIsGenerating'
	| 'thinkDeeperThinking'
	| 'responseComplete';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		conversationLimit: {
			id: 'ai-mate.chat-history.conversationLimit',
			defaultMessage:
				'Looking for an old chat? We clear out chat history after 30 days to keep our AI running smoothly.',
			description: 'Message displayed informing user about conversation history limits',
		},
		infoIconLabel: {
			id: 'ai-mate.chat-history.empty-state.message',
			defaultMessage: 'Get answers, generate new ideas, and accelerate everyday work.',
			description: 'The message displayed in the empty state of the chat history',
		},
		rovoIsThinking: {
			id: 'ai-mate.chat-history.loading-state.agent-is-thinking',
			defaultMessage: '{name} is thinking',
			description: 'The default message displayed for message traces',
		},
		agentIsGenerating: {
			id: 'ai-mate.chat-history.loading-state.agent-is-generating',
			defaultMessage: '{name} is generating',
			description: 'The message displayed when an action is streaming',
		},
		thinkDeeperThinking: {
			id: 'ai-mate.chat-history.loading-state.think-deeper-thinking',
			defaultMessage: 'Thinking deeply and analyzing',
			description: 'The message displayed for think deeper thinking',
		},
		responseComplete: {
			id: 'ai-mate.chat-history.loading-state.response-complete',
			defaultMessage: 'Response complete',
			description: 'Announced to screen readers when the AI finishes generating a response',
		},
	});

export default message;
